import { cx } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';

export interface CompareModelsTableCellProps extends PropsWithChildren {
  readonly isLastRow?: boolean;
}

const CompareModelsTableCell = ({
  children,
  isLastRow,
}: CompareModelsTableCellProps) => {
  return (
    <div
      className={cx('flex-1 text-sm lg:text-xl', {
        'pb-6 lg:border-b lg:border-gray-300': !isLastRow,
      })}
      data-cy="compare-models-table-cell"
      role="cell"
    >
      {children}
    </div>
  );
};

export default CompareModelsTableCell;
